import React, { useEffect, useState } from "react";
import Icon from "@material-ui/core/Icon";
import { makeStyles } from "@material-ui/core/styles";
import ChartistGraph from "react-chartist";
import EditIcon from '@material-ui/icons/Edit';
//import FilterAltIcon from '@material-ui/icons/FilterAlt';
import ReplayIcon from '@material-ui/icons/Replay';

// @material-ui/icons
import Store from "@material-ui/icons/Store";
import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Update from "@material-ui/icons/Update";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import AccessTime from "@material-ui/icons/AccessTime";
import Accessibility from "@material-ui/icons/Accessibility";
import BugReport from "@material-ui/icons/BugReport";
import Code from "@material-ui/icons/Code";
import Cloud from "@material-ui/icons/Cloud";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import AssignmentIcon from "@material-ui/icons/Assignment";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import ListIcon from "@material-ui/icons/List";
import LocalAtm from "@material-ui/icons/LocalAtm";

import Tasks from "../biztran_controls/Tasks/Tasks.js";
import Table from "../biztran_controls/Table/Table.js";
import CustomTabs from "../biztran_controls/CustomTabs/CustomTabs.js";
import GridItem from "../biztran_controls/Grid/GridItem";
import GridContainer from "../biztran_controls/Grid/GridContainer";

import Card from "../biztran_controls/Card/Card";
import CardHeader from "../biztran_controls/Card/CardHeader.js";
import CardIcon from "../biztran_controls/Card/CardIcon.js";
import CardBody from "../biztran_controls/Card/CardBody.js";
import CardFooter from "../biztran_controls/Card/CardFooter.js";
import Danger from "../biztran_controls/Typography/Danger";
import 'moment/locale/it.js';
import 'rc-datepicker/lib/style.css';
import { DatePickerInput } from 'rc-datepicker';
import UseFetchData from "../../hooks/UseFetchData";
import PersonIcon from '@material-ui/icons/Person';
import blue from "@material-ui/core/colors/blue";
import Moment from "moment";
import { Grid, IconButton, Typography, Popover, List, ListItem, ListItemAvatar, ListItemText, Avatar } from '@material-ui/core';

import { dailySalesChart, emailsSubscriptionChart, completedTasksChart } from "../../variables/charts";

import { activities, notes, others } from "../../variables/general.js";

import styles from "../../assets/jss/material-dashboard-react/views/dashboardStyle.js";

let fromDate = new Date().getFullYear() + "/04/01"

const useStyles = makeStyles(styles);

const Dashboard = () => {
  const classes = useStyles();

  const [FromDate, setFromDate] = useState(fromDate);
  const [UserName, setUserName] = useState(sessionStorage.UserName);
  const [UserID, setUserID] = useState(sessionStorage.UID);
  const [defaultfromDate, setdefaultfromDate] = useState(fromDate);
  const [ToDate, setToDate] = useState(new Date());
  const [defaultToDate, setdefaultToDate] = useState(new Date());
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [UserData, setUserData] = useState([]);
  const [ActivityData, setActivityData] = useState([]);
  const [NotesData, setNotesData] = useState([]);
  const [Q1Target, setQ1Target] = useState(0);
  const [Q1Actual, setQ1Actual] = useState(0);
  const [Q2Target, setQ2Target] = useState(0);
  const [Q2Actual, setQ2Actual] = useState(0);
  const [Q3Target, setQ3Target] = useState(0);
  const [Q3Actual, setQ3Actual] = useState(0);
  const [Q4Target, setQ4Target] = useState(0);
  const [Q4Actual, setQ4Actual] = useState(0);
  const [OPCount, setOPCount] = useState(0);
  const [QTCount, setQTCount] = useState(0);
  const [SOCount, setSOCount] = useState(0);
  const [OPTotal, setOPTotal] = useState(0);
  const [QTTotal, setQTTotal] = useState(0);
  const [SOTotal, setSOTotal] = useState(0);
  const [MaxTAC, setMaxTAC] = useState();
  const [MaxQT, setMaxQT] = useState();
  const [MaxAct, setMaxAct] = useState();
  const [ActivitytasksIndexes, setActivitytasksIndexes] = useState([]);
  const [NotestasksIndexes, setNotestasksIndexes] = useState([]);
  const [SalesAnalysisData, setSalesAnalysisData] = useState([]);
  const [TargetVsActualChart, setTargetVsActualChart] = useState();
  const [QuotationChart, setQuotationChart] = useState();
  const [ActivitiesChart, setActivitiesChart] = useState([]);
  const [responseUsers, fetchUsersData] = UseFetchData();
  const [responseDtls, fetchDtlsData] = UseFetchData();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleListItemClick = (value) => {
    //console.log(value);
    setUserID(value.id)
    setUserName(value.UserName)
    Populate(value.id);
    //Populate();
    handleClose();
  };

  const onFromClear = () => {
    setFromDate();
    setdefaultfromDate();
  }

  const onToClear = () => {
    setToDate();
    setdefaultToDate();
  }

  const AllUsersDtls = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("SearchString", '');
    fetchUsersData("User/List", bodyFormData);
  }

  const Populate = (UserID) => {
    debugger;
    var UID = "";
    if (UserID === "") {
      UID = sessionStorage.UID
    }
    else {
      UID = UserID
    }
    var bodyFormData = new FormData();
    bodyFormData.append("UserID", UID);
    bodyFormData.append("FinacialDate", Moment(fromDate).format('YYYY-MM-DD'));
    bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
    bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
    fetchDtlsData("Dashboard/View", bodyFormData);
  }

  useEffect(() => {
    AllUsersDtls();
    Populate('');

  }, []);

  useEffect(() => {
    if (responseUsers !== undefined && responseUsers.length > 0) {
      setUserData(responseUsers);
    }
  }, [responseUsers]);

  useEffect(() => {
    debugger;
    if (responseDtls.Activity !== undefined && responseDtls.Activity.length > 0) {
      var array = [];
      var index = [];
      for (var i = 0; i < responseDtls.Activity.length; i++) {
        //var act = responseDtls.Activity[i].Description;
        array.push(act);
        index.push(i);
      }
      //setActivityData(array);
      setActivityData(responseDtls.Activity);
      setActivitytasksIndexes(index);
    }
    else {
      setActivityData([]);
      setActivitytasksIndexes([0]);
    }

    if (responseDtls.Notes !== undefined && responseDtls.Notes.length > 0) {
      var array = [];
      var index = [];
      for (var i = 0; i < responseDtls.Notes.length; i++) {
        var act = responseDtls.Notes[i].Notes;
        array.push(act);
        index.push(i);
      }
      //setNotesData(array);
      setNotesData(responseDtls.Notes);
      setNotestasksIndexes(index);
    }
    else {
      setNotesData([]);
      setNotestasksIndexes([0]);
    }

    if (responseDtls.TargetVsActualChart !== undefined && responseDtls.TargetVsActualChart.length > 0) {
      var data = JSON.parse(responseDtls.TargetVsActualChart[0].TargetActual)
      debugger;
      if (data !== null) {
        const MaxTACData = Math.max(...data[0], ...data[1])
        setMaxTAC(MaxTACData + 1)
      }
      else {
        setMaxTAC(5)
      }
      var data = {
        labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar",],
        series: JSON.parse(responseDtls.TargetVsActualChart[0].TargetActual),
      }
      setTargetVsActualChart(data);
    }

    if (responseDtls.TargetVsActualQty !== undefined && responseDtls.TargetVsActualQty.length > 0) {
      for (var i = 0; i < responseDtls.TargetVsActualQty.length; i++) {
        if (responseDtls.TargetVsActualQty[i].Qty === 1) {
          setQ1Actual((responseDtls.TargetVsActualQty[i].Actual).toFixed(2));
          setQ1Target((responseDtls.TargetVsActualQty[i].Target).toFixed(2));
        }
        if (responseDtls.TargetVsActualQty[i].Qty === 2) {
          setQ2Actual((responseDtls.TargetVsActualQty[i].Actual).toFixed(2));
          setQ2Target((responseDtls.TargetVsActualQty[i].Target).toFixed(2));
        }
        if (responseDtls.TargetVsActualQty[i].Qty === 3) {
          setQ3Actual((responseDtls.TargetVsActualQty[i].Actual).toFixed(2));
          setQ3Target((responseDtls.TargetVsActualQty[i].Target).toFixed(2));
        }
        if (responseDtls.TargetVsActualQty[i].Qty === 4) {
          setQ4Actual((responseDtls.TargetVsActualQty[i].Actual).toFixed(2));
          setQ4Target((responseDtls.TargetVsActualQty[i].Target).toFixed(2));
        }
      }
    }

    if (responseDtls.AllDtlsData !== undefined && responseDtls.AllDtlsData.length > 0) {
      for (var i = 0; i < responseDtls.AllDtlsData.length; i++) {
        if (responseDtls.AllDtlsData[i].type === 'OP') {
          setOPCount(responseDtls.AllDtlsData[i].Count);
          setOPTotal(responseDtls.AllDtlsData[i].Total === null ? 0 : responseDtls.AllDtlsData[i].Total);
        }
        if (responseDtls.AllDtlsData[i].type === 'QT') {
          setQTCount(responseDtls.AllDtlsData[i].Count);
          setQTTotal(responseDtls.AllDtlsData[i].Total === null ? 0 : responseDtls.AllDtlsData[i].Total);
        }
        if (responseDtls.AllDtlsData[i].type === 'SO') {
          setSOCount(responseDtls.AllDtlsData[i].Count);
          setSOTotal(responseDtls.AllDtlsData[i].Total === null ? 0 : responseDtls.AllDtlsData[i].Total);
        }
      }
    }

    if (responseDtls.SalesAnalysisYearly !== undefined && responseDtls.SalesAnalysisYearly.length > 0) {
      var data = [];
      for (var i = 0; i < responseDtls.SalesAnalysisYearly.length; i++) {
        var sales = []
        sales.push(responseDtls.SalesAnalysisYearly[i].SalesName, responseDtls.SalesAnalysisYearly[i].Sales, responseDtls.SalesAnalysisYearly[i].Country);
        data.push(sales)
      }
      setSalesAnalysisData(data)
    }

    if (responseDtls.QuotationChart !== undefined && responseDtls.QuotationChart.length > 0) {
      var Month = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];
      var data = [];
      var flag = false;
      for (var i = 0; i < Month.length; i++) {
        flag = false;
        for (var j = 0; j < responseDtls.QuotationChart.length; j++) {
          if (responseDtls.QuotationChart[j].Mth === Month[i]) {
            flag = true;
            data.push(responseDtls.QuotationChart[j].Total);
          }
        }
        if (flag === false) {
          data.push(0);
        }
      }
      const MaxQTData = Math.max(...data)
      setMaxQT(MaxQTData + 1)
      var DtlsData = {
        labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar",],
        series: [{ data }],
      }
      setQuotationChart(DtlsData);
    }
    else {
      setMaxQT(5)
      var DtlsData = {
        labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar",],
        series: [[]],
      }
      setQuotationChart(DtlsData);
    }

    if (responseDtls.ActivitiesChart !== undefined && responseDtls.ActivitiesChart.length > 0) {
      var time = [24, 3, 6, 9, 12, 15, 18, 21];
      var data = [];
      var flag = false;
      for (var i = 0; i < time.length; i++) {
        flag = false;
        for (var j = 0; j < responseDtls.ActivitiesChart.length; j++) {
          if (responseDtls.ActivitiesChart[j].hr === time[i]) {
            flag = true;
            data.push(responseDtls.ActivitiesChart[j].count);
          }
        }
        if (flag === false) {
          data.push(0);
        }
      }
      const MaxActData = Math.max(...data);
      setMaxAct(MaxActData + 1);
      var DtlsData = {
        labels: ["12am", "3am", "6am", "9am", "12pm", "3pm", "6pm", "9pm"],
        series: [{ data }],
      }
      setActivitiesChart(DtlsData);
    }
  }, [responseDtls])

  return (
    <div>
      <Grid spacing={1} container direction="row">
        <Grid item xs={3}>
          <p className={classes.cardCategory} style={{ fontSize: 29, marginTop: 3 }}> Dashboard of {UserName} </p>
        </Grid>
        <Grid item xs={1}>
          <IconButton style={{ marginTop: 10 }} aria-describedby={id} variant="contained" onClick={handleClick}>
            <EditIcon />
          </IconButton>
        </Grid>
        <Grid item xs={4}></Grid>
        <Grid item xs></Grid>
        <Grid item xs>
          <div style={{ width: '160px' }}>
            <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
            <DatePickerInput
              onChange={(jsDate, dateString) => setFromDate(dateString)}
              locale="en"
              displayFormat="DD/MMM/YYYY"
              className='my-react-component'
              onClear={() => { onFromClear(); }}
              showOnInputClick
              maxDate={new Date()}
              returnFormat="YYYY/MM/DD"
              defaultValue={defaultfromDate}
            />
          </div>
        </Grid>
        <Grid item xs>
          <div style={{ width: '160px' }} >
            <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
            <DatePickerInput
              onChange={(jsDate, dateString) => setToDate(dateString)}
              locale="en"
              displayFormat="DD/MMM/YYYY"
              className='my-react-component'
              onClear={() => { onToClear(); }}
              showOnInputClick
              maxDate={new Date()}
              returnFormat="YYYY/MM/DD"
              defaultValue={defaultToDate}
            />
          </div>
        </Grid>
        <Grid item xs>
          <IconButton style={{ marginTop: 13 }}>
            <ReplayIcon onClick={() => { Populate(UserID); }} />
          </IconButton>
        </Grid>
      </Grid>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <Card chart>
            <CardHeader color="info">
              <ChartistGraph
                className="ct-chart"
                data={TargetVsActualChart}
                type="Bar"
                options={{
                  axisX: {
                    showGrid: false,
                  },
                  low: 0,
                  high: MaxTAC,
                  chartPadding: {
                    top: 0,
                    right: 5,
                    bottom: 0,
                    left: 0,
                  },
                }}
                responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                listener={emailsSubscriptionChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Monthly Target Vs Actual</h4>
              <p className={classes.cardCategory}>Target Vs Actual</p>
              <Grid spacing={1} container direction="row">
                <Grid item xs={6}>
                  <Card>
                    <CardHeader color="success" stats icon>
                      <CardIcon color="success">
                        <h3>Q1</h3>
                      </CardIcon>
                      <div style={{ display: 'flex', flexDirection: 'column', float: 'right', paddingTop: 7 }}>
                        <p className={classes.cardCategory} style={{ fontSize: 16, display: 'flex', flexDirection: 'row' }} >Target: <h3 style={{paddingLeft:5,width:65, display: 'flex', float:'left'}}>{Q1Target}</h3></p>
                        <p className={classes.cardCategory} style={{ fontSize: 16, display: 'flex', flexDirection: 'row' }} >Actual: <h3 style={{paddingLeft:5,width:65, display: 'flex', float:'left'}}>{Q1Actual}</h3></p>
                      </div>
                    </CardHeader>
                  </Card>
                </Grid>
                <Grid item xs={6}>
                  <Card>
                    <CardHeader color="info" stats icon>
                      <CardIcon color="info">
                        <h3>Q2</h3>
                      </CardIcon>
                      <div style={{ display: 'flex', flexDirection: 'column', float: 'right', paddingTop: 7 }}>
                        <p className={classes.cardCategory} style={{ fontSize: 16, display: 'flex', flexDirection: 'row' }} >Target: <h3 style={{paddingLeft:5,width:65, display: 'flex', float:'left'}}>{Q2Target}</h3></p>
                        <p className={classes.cardCategory} style={{ fontSize: 16, display: 'flex', flexDirection: 'row' }} >Actual: <h3 style={{paddingLeft:5,width:65, display: 'flex', float:'left'}}>{Q2Actual}</h3></p>
                      </div>
                    </CardHeader>
                  </Card>
                </Grid>
                <Grid item xs={6} style={{ marginTop: -25 }}>
                  <Card>
                    <CardHeader color="danger" stats icon>
                      <CardIcon color="danger">
                        <h3>Q3</h3>
                      </CardIcon>
                      <div style={{ display: 'flex', flexDirection: 'column', float: 'right', paddingTop: 7 }}>
                        <p className={classes.cardCategory} style={{ fontSize: 16, display: 'flex', flexDirection: 'row' }} >Target: <h3 style={{paddingLeft:5,width:65, display: 'flex', float:'left'}}>{Q3Target}</h3></p>
                        <p className={classes.cardCategory} style={{ fontSize: 16, display: 'flex', flexDirection: 'row' }} >Actual: <h3 style={{paddingLeft:5,width:65, display: 'flex', float:'left'}}>{Q3Actual}</h3></p>
                      </div>
                    </CardHeader>
                  </Card>
                </Grid>
                <Grid item xs={6} style={{ marginTop: -25 }}>
                  <Card>
                    <CardHeader color="warning" stats icon>
                      <CardIcon color="warning">
                        <h3>Q4</h3>
                      </CardIcon>
                      <div style={{ display: 'flex', flexDirection: 'column', float: 'right', paddingTop: 7 }}>
                        <p className={classes.cardCategory} style={{ fontSize: 16, display: 'flex', flexDirection: 'row' }} >Target: <h3 style={{paddingLeft:5,width:65, display: 'flex', float:'left'}}>{Q4Target}</h3></p>
                        <p className={classes.cardCategory} style={{ fontSize: 16, display: 'flex', flexDirection: 'row' }} >Actual: <h3 style={{paddingLeft:5,width:65, display: 'flex', float:'left'}}>{Q4Actual}</h3></p>
                      </div>
                    </CardHeader>
                  </Card>
                </Grid>
              </Grid>
            </CardBody>
            {/* <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> last sales order was 2 days ago
              </div>
            </CardFooter> */}
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <CustomTabs
            title="Details : "
            headerColor="primary"
            tabs={[
              {
                tabName: "Activities", 
                tabIcon: Code,
                tabContent: (
                  <Tasks
                    value={0}
                    checkedIndexes={[0, 3]}
                    tasksIndexes={ActivitytasksIndexes}
                    tasks={ActivityData}
                  />
                ),
              },
              {
                tabName: "Notes",
                tabIcon: AssignmentIcon,
                tabContent: (
                  <Tasks
                    value={1}
                    checkedIndexes={[0]}
                    tasksIndexes={NotestasksIndexes}
                    tasks={NotesData}
                  />
                ),
              },
              /* {
                tabName: "Extra",
                tabIcon: LocalAtm,
                tabContent: (
                  <Tasks
                    checkedIndexes={[1]}
                    tasksIndexes={[0, 1, 2]}
                    tasks={others}
                  />
                ),
              }, */
            ]}
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <div style={{ height: 100 }} >
            <Card>
              <CardHeader color="warning" stats icon>
                <CardIcon color="warning">
                  <BusinessCenterIcon />
                </CardIcon>
                <p className={classes.cardCategory}>Opportunity</p>
                <h3 className={classes.cardTitle}>
                  {OPCount}
                </h3>
                <p className={classes.cardCategory} style={{ marginTop: -9 }}>₹ {OPTotal}</p>
              </CardHeader>
              {/* <CardFooter stats>
              <div className={classes.stats}>
                <LocalOffer />₹ {OPTotal}
                <div className={classes.statslink}>
                  <ListIcon />
                  View Opportunities
                </div>
              </div>
            </CardFooter> */}
            </Card>
          </div>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <LocalAtm />
              </CardIcon>
              <p className={classes.cardCategory}>Quotation</p>
              <h3 className={classes.cardTitle}>{QTCount}</h3>
              <p className={classes.cardCategory} style={{ marginTop: -9 }}>₹ {QTTotal}</p>
            </CardHeader>
            {/* <CardFooter stats>
              <div className={classes.stats}>
                <LocalOffer />₹ {QTTotal}
                <div className={classes.statslink}>
                  <ListIcon />
                  View Quotations
                </div>
              </div>
            </CardFooter> */}
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <AssignmentIcon />
              </CardIcon>
              <p className={classes.cardCategory}>Sales Order</p>
              <h3 className={classes.cardTitle}>{SOCount}</h3>
              <p className={classes.cardCategory} style={{ marginTop: -9 }}>₹ {SOTotal}</p>
            </CardHeader>
            {/* <CardFooter stats>
              <div className={classes.stats}>
                <LocalOffer />₹ {SOTotal}
                <div className={classes.statslink}>
                  <ListIcon />
                  View Sales Orders
                </div>
              </div>
            </CardFooter> */}
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="danger" stats icon>
              <CardIcon color="danger">
                {/* <div style={{width:25,height:25}}>
                <Accessibility style={{marginTop:-5,marginLeft:-5}}/>
                </div> */}
                <Accessibility />
              </CardIcon>
              <p className={classes.cardCategory}>Customer Complaint</p>
              <h3 className={classes.cardTitle}>+245</h3>
              <p className={classes.cardCategory} style={{ marginTop: -9 }}>Average TAT - 3.5 Days</p>
            </CardHeader>
            {/* <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Average TAT - 3.5 Days
                <div className={classes.statslink}>
                  <ListIcon />
                  View
                </div>
              </div>
            </CardFooter> */}
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="warning">
              <h4 className={classes.cardTitleWhite}>
                Sales Analysis
              </h4>
              <p className={classes.cardCategoryWhite}>
                Sales Analysis - Current Year
              </p>
            </CardHeader>
            <CardBody>
              <Table
                tableHeaderColor="warning"
                tableHead={["Name", "Sales", "Country"]}
                tableData={SalesAnalysisData}
              />
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Card chart>
            <CardHeader color="success">
              <ChartistGraph
                className="ct-chart"
                data={QuotationChart}
                type="Line"
                options={{
                  //lineSmooth: Chartist.Interpolation.cardinal({
                  //tension: 0,
                  //}),
                  low: 0,
                  high: MaxQT, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
                  chartPadding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                  },
                }}
                listener={dailySalesChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Monthly Quotations</h4>
              <p className={classes.cardCategory}>
                <span className={classes.successText}>
                  <ArrowUpward className={classes.upArrowCardCategory} /> 55%
                </span>{" "}
                increase in today quotations.
              </p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> updated 4 minutes ago
              </div>
            </CardFooter>
          </Card>
          <Card chart>
            <CardHeader color="danger">
              <ChartistGraph
                className="ct-chart"
                data={ActivitiesChart}
                type="Line"
                options={{
                  //lineSmooth: Chartist.Interpolation.cardinal({
                  //tension: 0,
                  //}),
                  low: 0,
                  high: MaxAct, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
                  chartPadding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                  },
                }}
                listener={completedTasksChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Completed Activities</h4>
              <p className={classes.cardCategory}>Activity Performance</p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> last activity completed 2 hrs ago
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <List sx={{ pt: 0 }}>
          {UserData.map((Users) => (
            <ListItem button onClick={() => handleListItemClick(Users)} key={Users.id}>
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                  <PersonIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={Users.UserName} />
            </ListItem>
          ))}
        </List>
      </Popover>
    </div>
  );
};

export default Dashboard;
